import { EnvVariables } from '../interfaces/EnvVariables';
import { Environment } from '../enums/Environment';

export const ENV: EnvVariables = {
  PORT: parseInt(process.env.PORT, 10),
  BUILD_PATH: process.env.BUILD_PATH,
  FIDES_USER_ID: process.env.FIDES_USER_ID,
  HOST: process.env.HOST,
  PUBLIC_URL: process.env.PUBLIC_URL,
  SUB_FOLDER: process.env.REACT_APP_SUB_FOLDER,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT as Environment,
  DEFAULT_LANGUAGE_CODE: process.env.REACT_APP_DEFAULT_LANGUAGE_CODE,
  DEFAULT_LANGUAGE_NAME: process.env.REACT_APP_DEFAULT_LANGUAGE_NAME,
  PORTAL_API_URL: process.env.REACT_APP_PORTAL_API_URL,
  ARS_API_URL: process.env.REACT_APP_ARS_API_URL,
  EFT_API_URL: process.env.REACT_APP_EFT_API_URL,
  CPS_API_URL: process.env.REACT_APP_CPS_API_URL,
  DLC_API_URL: process.env.REACT_APP_DLC_API_URL,
  EFT_URL: process.env.REACT_APP_EFT_URL,
  APP_VERSION: process.env.REACT_APP_VERSION,
  CS_CLIENT_ID: process.env.REACT_APP_CS_CLIENT_ID,
  PORTAL_DIRECTORY: process.env.REACT_APP_PORTAL_DIRECTORY,
};
